module.exports = __webpack_public_path__ + "img/fabrica.ea220fcf.jpeg";